export * from './user/user.service';
export * from './page/page.service';
export * from './common/common.service';
export * from './site/site.service';
export * from './device/device.service';
export * from './zone/zone.service';
export * from './brand/brand.service';
export * from './role/role.service';
export * from './customer/customer.service';
export * from './package/package.service';
export * from './event/event.service';
export * from './dashboard/dashboard.service';
export * from './group/group.service';
export * from './widget/widget.service';
export * from './playlist/playlist.service';
export * from './faq/faq.service';
export * from './acl/acl.service';
export * from './scheduler/scheduler.service';
export * from './future-operational-hours/future-operational-hours.service'


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/index.ts